import React, {useEffect} from 'react';
import CookieConsent, { Cookies, resetCookieConsentValue } from 'react-cookie-consent';
import { CookieInfo } from '../QuickQuoteForm/types';
import styles from './CookieConsent.module.scss';
import { baseURL } from 'common/constants/common';
import CookieSettings from './CookieSettings';
import classNames from 'classnames';

interface ConsentObj {
  [key: string]: boolean;
}

const CookieConsentModal = (cookieInfo: CookieInfo) => {
  const [hideSettings, setHideSettings] = React.useState<boolean>(true);
  const [isVisible, setIsVisible] = React.useState<string>('byCookieValue');
  const [allowedCookies, setAllowedCookies] = React.useState<{[key: string]: boolean}>({
    'Performance & Targeting': true,
    Functional: true,
    '3rd Party Testing': true,
  });
  const cookieName = JSON.stringify(allowedCookies).replace(/[ "{}]/g, '').replace(/,/g, '#');
  const {
    cookieAcceptButton, cookieSettingsButton, cookieHeader, cookieContent,
  } = cookieInfo;

  useEffect(() => {
    const cookieConsent = getCookieValue('CookieConsent');
    if (cookieConsent) {
      const consents = cookieConsent.split('#');
      const consentObj = consents.reduce((acc: ConsentObj, consent) => {
        let [key, value] = consent.split(':');
        
        // key = key.replace(/&([A-Z])/g, ' & $1').replace(/(?<!\s)([A-Z])/g, ' $1').trim(); 
        key = key.replace(/&([A-Z])/g, ' & $1').replace(/([a-z0-9])([A-Z])/g, '$1 $2').replace(/([A-Z])([A-Z][a-z])/g, '$1 $2');
        
        acc[key] = value === 'true';
        return acc;
      }, {});

      setAllowedCookies(consentObj);
    }
  }, []);
  // A helper function to get the cookie value
  function getCookieValue(name:string) {
    const matches = document.cookie.match(new RegExp(
      "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
  }

  const handleDecline = () => {
    setHideSettings((hide) => !hide);
    resetCookieConsentValue();
  };
  
  const handleOK = () => {
    setIsVisible('hidden');
    window.location.reload();
  }

  const onCookieHide = (ifAcceptAll:boolean) => {
    if (ifAcceptAll) {
      setAllowedCookies(() => ({
        'Performance & Targeting': true,
        Functional: true,
        '3rd Party Testing': true,
      }));
    }
    document.getElementById('rcc-confirm-button')?.click();
    setIsVisible('hidden');
  };

  useEffect(() => {
    document.getElementById('triggerCookieConsent')?.addEventListener('click', () => {
      setIsVisible('show');
      setHideSettings(false);
    });
  });

  const isCookiesAccepted = Boolean(Cookies.get('CookieConsent'))

  const hideContent = classNames({
    [styles.hideContent]: isCookiesAccepted,
  });

  return (
    <CookieConsent
      buttonClasses={`${styles.cookieAcceptButton} ${hideContent}`}
      buttonText={cookieAcceptButton}
      containerClasses={`${styles.cookieContainer} ${hideContent}`}
      contentClasses={`${styles.cookieContent} ${hideContent}`}
      cookieValue={cookieName}
      declineButtonClasses={`${styles.cookieSettingsButton} ${hideContent}`}
      declineButtonText={cookieSettingsButton}
      enableDeclineButton
      expires={365}
      hideOnDecline={false}
      onAccept={handleOK}
      onDecline={handleDecline}
      overlay
      visible={isVisible}
    >
      <CookieSettings
        {...cookieInfo}
        allowedCookies={allowedCookies}
        closeSettings={setHideSettings}
        isHidden={hideSettings}
        onCookieHide={onCookieHide}
        setAllowedCookies={setAllowedCookies}
      />
      <p className={styles.cookieHeader}>
        {cookieHeader}
      </p>
      {cookieContent}
      <a className={`${styles.cookieLink} ${hideContent}`} href={`${baseURL}privacy-policy`} target="_blank"> Privacy and Cookie Policy.</a>
    </CookieConsent>
  );
};

export default CookieConsentModal;
